'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.modalTransitionContextPropType = exports.ConsumesModalTransitionContext = exports.Provider = exports.Consumer = exports.defaultValues = exports.types = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _consumerDecoratorFactory = require('./consumerDecoratorFactory');

var _consumerDecoratorFactory2 = _interopRequireDefault(_consumerDecoratorFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var types = exports.types = {
  transitioning: _react.PropTypes.bool.isRequired
};

var defaultValues = exports.defaultValues = {
  transitioning: false
};

var _React$createContext = _react2.default.createContext(defaultValues),
    Consumer = _React$createContext.Consumer,
    Provider = _React$createContext.Provider;

exports.Consumer = Consumer;
exports.Provider = Provider;
var ConsumesModalTransitionContext = exports.ConsumesModalTransitionContext = (0, _consumerDecoratorFactory2.default)('modalTransition', Consumer);

var modalTransitionContextPropType = exports.modalTransitionContextPropType = _react.PropTypes.shape(types);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1755/js/context/ModalTransitionContext.js
// module id = 952
// module chunks = 2 3